import { APARTMENT } from 'portal-modules/my-apartment/constants/urls'
import { LEASE_OPTIONS } from 'portal-modules/lease-options/constants/urls'
import { COMMUNITY } from 'portal-modules/community/constants/urls'
import { MESSAGES } from 'portal-modules/messages/constants/urls'
import { PAYMENTS } from 'portal-modules/payments/constants/urls'
import { AMENITIES } from 'App/components/Amenities/urls'
import { INSPECTIONS } from 'portal-modules/inspections/constants/urls'
import { UTILITIES } from 'portal-modules/utilities/constants/urls'
import { TRANSFER } from 'portal-modules/transfers/constants/urls'
import { OFFICE_INFO } from 'portal-modules/office-information/constants/urls'
import { REFERRALS } from 'portal-modules/referrals/constants/urls'
import { EMERGENCY_CONTACTS } from 'portal-modules/contacts/constants/urls'
import { CLASSIFIEDS } from 'portal-modules/classifieds/constants/urls'
import { REVIEWS } from 'portal-modules/reviews/constants/urls'
import { INSURANCE } from 'portal-modules/insurance/constants/urls'
import { VEHICLES } from 'portal-modules/vehicles/constants/urls'
import { GUEST_LIST } from 'portal-modules/guests/constants/urls'
import { DOCUMENTS } from 'portal-modules/documents/constants/urls'
import { EVENTS } from 'portal-modules/events/constants/urls'
import { MAINTENANCE } from 'portal-modules/maintenance/constants/urls'
import { SERVICES } from 'portal-modules/services/constants/urls'
import { RENTABLE_ITEMS } from 'portal-modules/rentable-items/constants/urls'
import { CLUBS } from 'portal-modules/clubs/constants/urls'
import { PROPERTY_SERVICES } from 'portal-modules/property-services/constants/urls'
import { SETTINGS } from 'portal-modules/settings/constants/urls'
import { EXTENSION } from 'portal-modules/extensions/constants/urls'
import { ENTRATAFI } from 'portal-modules/entratafi/constants/urls'
import { RENEWAL } from 'portal-modules/renewals/constants/urls'

export const getLandingPage = ({ landingPage }) => {
  const LANDING_PAGE_URLS = {
    2: AMENITIES.ROOT,
    18: INSPECTIONS.ROOT,
    23: UTILITIES.ROOT,
    22: TRANSFER,
    7: OFFICE_INFO.ROOT + '?activefilter',
    10: REFERRALS,
    16: EMERGENCY_CONTACTS,
    1: COMMUNITY.ROOT,
    11: MESSAGES.SEND_MESSAGE,
    4: CLASSIFIEDS.ROOT,
    8: REVIEWS,
    19: INSURANCE.ROOT,
    24: VEHICLES,
    17: GUEST_LIST,
    15: DOCUMENTS.ROOT,
    6: EVENTS.ROOT,
    // Devices: PRIVATE_ROOT,
    20: MAINTENANCE.ROOT,
    13: MESSAGES.ROOT,
    43: EXTENSION,
    14: APARTMENT.ROOT,
    45: LEASE_OPTIONS.ROOT,
    25: PAYMENTS.ROOT,
    9: SERVICES.ROOT,
    21: RENTABLE_ITEMS.ROOT,
    41: CLUBS.ROOT,
    39: PROPERTY_SERVICES.ROOT,
    Settings: SETTINGS.ROOT,
    Bulk_Payments: PAYMENTS.BULK_PAYMENTS,
    42: ENTRATAFI.ROOT,
    47: RENEWAL.RENEWAL_REQUEST.ROOT,
  }

  return LANDING_PAGE_URLS[landingPage]
}
